import React, { useEffect, useState, useRef, useMemo, createContext, useContext, useCallback } from 'react';
import { useSystemConfig } from '../contexts/SystemConfigContext';
import { trackFirstEntityCreatedOnce } from '../utils/analytics';
import { SetAppointmentInvoiceAPI, SetPatientDocumentAPI } from './API';
import { UpdateCompanyAPI, UpdateCompanyConfigAPI, GetCompanyConfigAPI, GetSessionAPI, RefreshTokenAPI } from './API';
import { GetUserProfileAPI, UpdateUserProfileAPI, UpdateUserPictureAPI, UpdateUserPasswordAPI, ListUserSessionsAPI, RevokeUserSessionAPI, GetCommunicationPreferencesAPI, UpdateCommunicationPreferencesAPI } from './API';
import { GetDashboardAPI, GetAppointmentsKpiAPI } from './API';
import { GetReportsAppointmentsAPI, GetReportsFinancialAPI } from './API';
import { GetPatientsAPI, SetPatientAPI, UpdatePatientAPI } from './API';
import { GetAppointmentsAPI, SetAppointmentAPI, UpdateAppointmentAPI, DeleteAppointmentAPI } from './API';
import { PreviewRecurringAppointmentsAPI, CreateRecurringAppointmentsAPI } from './API';
import { GetCEPInfoAPI } from './API';
import { SetPatientAnamneseAPI, UpdatePatientAnamneseAPI, DeletePatientAnamneseAPI } from './API';
import { SetPatientHistoryAPI, SetPatientNoteAPI, AnnulPatientHistoryRecordAPI, CreateReplacementHistoryRecordAPI } from './API';
import { SetPatientCranialAsymmetryAPI, UpdatePatientCranialAsymmetryAPI, DeletePatientCranialAsymmetryAPI } from './API';
import { SetPatientBodyMeasurementsAPI, UpdatePatientBodyMeasurementsAPI, DeletePatientBodyMeasurementsAPI, SetPatientBodyMapAPI, SetPatientMealPlanAPI, UpdatePatientMealPlanAPI, DeletePatientMealPlanAPI, SetPatientApplicationMapAPI, SetApplicationProductsAPI, SetPatientScaleAssessmentAPI, SetPatientGrowthMeasurementAPI, DeletePatientGrowthMeasurementAPI, SetPatientMotorMilestoneAPI, DeletePatientMotorMilestoneAPI, SetPatientThermographyAPI, DeletePatientThermographyAPI, SetPatientAimsAssessmentAPI, DeletePatientAimsAssessmentAPI, SetPatientBirthInfoAPI, SetPatientPrescriptionAPI, DeletePatientPrescriptionAPI, SetPrescriptionTemplateAPI, DeletePrescriptionTemplateAPI, SearchIcdAPI, SetPatientDiagnosisAPI, DeletePatientDiagnosisAPI } from './API';
import { UploadPatientAttachmentAPI, ListPatientAttachmentsAPI, UpdatePatientAttachmentAPI, DeletePatientAttachmentAPI, GetPatientAttachmentFileAPI, CreatePatientRegistrationLinkAPI, SendPatientRegistrationLinkWhatsAppAPI, SetPatientRegistrationLinkOriginAPI, CreateAppointmentReservationAPI, GetAppointmentReservationAPI, ResendAppointmentReservationAPI, NotifyReleasedAppointmentReservationAPI } from './API';
import { AnalyzeCranialImageAPI } from './API';
import { GetInvoiceAPI, UpdateInvoiceAPI, UpdateInvoiceNfIssuedAPI, DeleteInvoiceAPI } from './API';
import {
  GetWaitingListAPI, SetWaitingListAPI, UpdateWaitingListAPI, DeleteWaitingListAPI, CheckWaitingListAvailabilityAPI,
  GetWaitingListOffersAPI, SetWaitingListOfferAPI, UpdateWaitingListOfferAPI
} from './API';
import { GetLeadsAPI, SetLeadAPI, UpdateLeadAPI, FindLeadByPhoneAPI, DeleteLeadAPI } from './API';
import { GetCampaignsAPI, SetCampaignAPI, UpdateCampaignAPI, DeleteCampaignAPI, GetCampaignsBySourceAPI } from './API';
import { GetSourcesAPI, SetSourceAPI, UpdateSourceAPI, DeleteSourceAPI } from './API';
import { GetTemplatesDocumentsAPI, SetTemplatesDocumentsAPI, UpdateTemplatesDocumentsAPI, DeleteTemplatesDocumentsAPI } from './API';
import { InviteUserAPI, RegisterAPI, AcceptInviteAPI, GetCompanyUsersAPI, RevokeUserAPI, UpdateUserAPI, TransferOwnershipAPI, SetHealthProfessionalAPI, SetScheduleLinkAPI, ReactivateUserAPI, CancelInviteAPI, ResendInviteAPI } from './API';
import { ROLE_IDS } from '../constants/userRoles';
import { SendWhatsappMessageAPI, GetWhatsappChatsAPI, GetWhatsappChatMessagesAPI, SetWhatsappChatReadAPI, GetWhatsappContactContextAPI, GetWhatsappConfigAPI, SetWhatsappConfigAPI, TestWhatsappConfigAPI, GetWhatsappDeviceInfoAPI, GetWhatsappQRCodeAPI, GetWhatsappPhoneCodeAPI, SendWhatsappDocumentAPI, DisconnectWhatsappAPI, GetWhatsappSenderStatusAPI, SetWhatsappSenderTogglesAPI, NotifyAppointmentPatientWhatsAppAPI } from './API';
import { GetGoogleBusinessConfigAPI, SetGoogleBusinessConfigAPI } from './API';
import { GenerateAISimulatorReplyAPI, GetAISettingsAPI, SetAISettingsAPI, GetWhatsappAISuggestionAPI, SetWhatsappAISuggestionOutcomeAPI } from './API';
import { GetMassMessagingRecipientsAPI, SendMassMessageAPI, GetPredefinedQueriesAPI, GetMassMessageHistoryAPI, CheckRecipientMassMessageHistoryAPI } from './API';
import { GetNPSResponsesAPI, SetNPSResponseAPI, UpdateNPSGoogleReviewAPI, PrepareManualNPSMessageAPI, GetGoogleReviewSuggestionsAPI } from './API';
import { GetCompanyMessageTemplatesAPI, UpdateCompanyMessageTemplateAPI } from './API';
import { GetAnamnesisTemplatesAPI, SetAnamnesisTemplateAPI, UpdateAnamnesisTemplateAPI, DeleteAnamnesisTemplateAPI } from './API';
import { GetAppointmentTypesAPI, SetAppointmentTypeAPI, UpdateAppointmentTypeAPI, DeactivateAppointmentTypeAPI, GetInactiveAppointmentTypesAPI, ReactivateAppointmentTypeAPI } from './API';
import { GetAppointmentStepsAPI, SetAppointmentStepAPI, SetAppointmentStepActiveAPI, ReorderAppointmentStepsAPI, CheckAppointmentStepAPI, SetAppointmentStatusColorAPI } from './API';
import { setStatusColorOverrides } from '../consts/AppointmentStatusColors';
import { GetCompanyAutomationSettingsAPI, UpdateCompanyAutomationSettingAPI } from './API';
import {
  ReportProblemAPI,
  SuggestImprovementAPI,
  EvaluateProductAPI,
  ContactAPI,
  GetSystemFeedbackAPI,
  UpdateSystemFeedbackAPI,
  GetSystemNpsAPI,
  GetUserNpsAPI,
  UploadFeedbackFileAPI
} from './API';
import {
  GetSubscriptionPlansAPI,
  GetCompanySubscriptionAPI,
  GetSubscriptionPaymentHistoryAPI,
  UpdateCompanySubscriptionPlanAPI,
  SimulatePlanChangeAPI,
  GetSubscriptionHistoryAPI,
  CancelCompanySubscriptionAPI,
  CancelSpecificSubscriptionAPI,
  CreateStripeCheckoutSessionAPI,
  CreateStripeCustomerPortalAPI,
  GetStripeCheckoutSessionAPI,
  GetStripeConfigAPI,
} from './API';
import {
  GetCompanySetupStatusAPI,
  UpdateCompanySetupStatusAPI
} from './API';
import {
  GetCompanyResourcesAPI,
  SetCompanyResourceAPI,
  UpdateCompanyResourceAPI,
  DeleteCompanyResourceAPI,
  GetCompanyProceduresAPI,
  SetCompanyProcedureAPI,
  UpdateCompanyProcedureAPI,
  DeleteCompanyProcedureAPI,
  GetCompanyPaymentMethodsAPI,
  SetCompanyPaymentMethodAPI,
  UpdateCompanyPaymentMethodAPI,
  DeleteCompanyPaymentMethodAPI
} from './API';
import {
  GetFinancialCategoriesAPI,
  SetFinancialCategoryAPI,
  UpdateFinancialCategoryAPI,
  DeleteFinancialCategoryAPI,
  UpdateFinancialTransactionAPI,
  GetFinancialTransactionsAPI,
  GetFinancialDashboardAPI,
  DeleteFinancialTransactionAPI,
  SetFinancialTransactionAPI,
  GetActiveRecurringTransactionsAPI,
  CreateExportJobAPI,
  GetExportStatusAPI,
  GetExportHistoryAPI,
  CancelExportAPI,
  GetExportEstimateAPI,
  GetBackupStatusAPI
} from './API';
import {
  GetPatientWalletAPI,
  GetWalletTransactionsAPI,
  GetServicePackagesAPI,
  PurchaseServicePackageAPI,
  CreateServicePackageAPI,
  UpdateServicePackageAPI,
  DeleteServicePackageAPI,
  DeductWalletCreditsAPI,
  AcceptTermsAPI,
  CheckTermsAcceptedAPI,
  GetTermsContentAPI
} from './API';
import {
  GetCompanyRoomsAPI,
  SetCompanyRoomAPI,
  UpdateCompanyRoomAPI,
  DeleteCompanyRoomAPI,
  GetRoomOccupancyAPI,
  GetRoomsOccupancyBatchAPI,
  GetDayRoomsAPI,
  SetDayRoomAPI
} from './API';
import {
  GetInsuranceProvidersAPI,
  SetInsuranceProviderAPI,
  UpdateInsuranceProviderAPI,
  SearchTussProceduresAPI,
  SetInsuranceProcedureAPI,
  UpdateInsuranceProcedureAPI,
  CopyInsuranceProceduresAPI,
  GetPatientInsurancesAPI,
  SetPatientInsuranceAPI,
  UpdatePatientInsuranceAPI,
  GetPatientInsuranceDocumentsAPI,
  SetMedicalRequestAPI,
  UpdateMedicalRequestAPI,
  SetInsuranceAuthorizationAPI,
  UpdateInsuranceAuthorizationAPI,
  GetAppointmentInsuranceDocumentsAPI,
  LinkAppointmentInsuranceDocumentAPI,
  UnlinkAppointmentInsuranceDocumentAPI,
  GetUpcomingRequestTargetsAPI,
  LinkUpcomingRequestAPI,
  GetInsurancePendingAPI
} from './API';
import {
  GetFiscalSettingsAPI,
  SetFiscalSettingsAPI,
  GetFiscalInvoiceAPI,
  GetFiscalInvoiceHistoryAPI,
  CreateFiscalInvoiceAPI,
  RefreshFiscalInvoiceStatusAPI,
  SendFiscalInvoiceWhatsAppAPI,
  DownloadFiscalFileAPI,
  GetFiscalInvoiceDownloadUrl,
  CancelFiscalInvoiceAPI,
} from './FiscalAPI';

// DataProvider.js - Provides data access functions for the application
const DataContext = createContext();

export const DataProvider = ({ children, session, OnComplete }) => {
  const [isUpdating, setIsUpdating] = useState(false);
  const [currentSession, setCurrentSession] = useState(session);
  const [userProfile, setUserProfile] = useState(null);
  const [CompanyConfig, setCompanyConfig] = useState(null);
  const [patients, SetPatients] = useState([]);
  // Quando a lista veio da API pela última vez (ms): a tela de pacientes não baixa de
  // novo uma lista que acabou de chegar (PERF-01, 18 mil pacientes = 10 MB por carga).
  const [patientsLoadedAt, setPatientsLoadedAt] = useState(0);
  // Índice por id: a agenda e o Início resolvem o nome de cada agendamento por aqui;
  // procurar na lista inteira custava meio segundo por tela numa conta grande.
  const patientsById = useMemo(() => {
    const map = new Map();
    for (const patient of patients) map.set(String(patient.id), patient);
    return map;
  }, [patients]);
  const [appointments, setAppointments] = useState([]);
  const [messageTemplates, setMessageTemplates] = useState([]);
  const { config: systemConfig } = useSystemConfig();

  // Refresh session and token periodically
  useEffect(() => {
    const refreshSession = () => {
      GetSessionAPI((result) => {
        if (!result.error) {
          setCurrentSession(result.session);
        }
      });
    };
    
    // Proactively refresh the access token before it expires.
    // O refresh token vai no cookie HttpOnly (L-21); a camada de API compartilha a
    // renovação em andamento, então não há corrida com um 401 simultâneo.
    const refreshToken = () => {
      // Refresh the token
      RefreshTokenAPI((result) => {
        if (!result.error) {
          // Token refreshed successfully
          window.visualLogger?.log('Token renovado proativamente com sucesso');
        } else {
          // If refresh failed but not due to expired refresh token, log the error
          if (result.code !== 'refresh_token_expired') {
            window.visualLogger?.error('Falha ao renovar token proativamente: ' + result.error);
          }
        }
      });
    };

    // Refresh session every 5 minutes
    const sessionInterval = setInterval(refreshSession, 5 * 60 * 1000);
    
    // Refresh token every 45 minutes (assuming 1-hour token lifetime).
    // Sem renovação imediata ao montar: o boot ou o login acabaram de emitir o token.
    const tokenInterval = setInterval(refreshToken, 45 * 60 * 1000);
        
    return () => {
      clearInterval(sessionInterval);
      clearInterval(tokenInterval);
    };
  }, []);

  // Fetch user profile data
  useEffect(() => {
    if (currentSession?.user?.id) {
      GetUserProfileAPI((result) => {
        if (result.success && result.user) {
          setUserProfile(result.user);
        }
      });
    }
  }, [currentSession]);
// Get current user data and company ID from session


const userData = userProfile || (currentSession?.user ? {
  ...currentSession.user,
  // Add role from the current company
  role: currentSession?.companies?.find(company => {
    return company?.id == currentSession?.currentCompany;
  })?.role?.name || ''
} : null);


const companyId = currentSession?.currentCompany;

  // Add retry mechanism for data loading
  const [retryCount, setRetryCount] = useState(0);
  const maxRetries = 3;
  // Empresa cujos dados iniciais já foram carregados: evita recarregar quando
  // retryCount volta a 0 após o sucesso (retryCount está nas dependências para as tentativas).
  const loadedCompanyIdRef = useRef(null);

  useEffect(() => {
    if (companyId == null) {

      return;
    }

    if (loadedCompanyIdRef.current === companyId) {
      return;
    }

    if (!systemConfig) {
      
      
      // If we haven't reached max retries, set up a retry
      if (retryCount < maxRetries) {
        const nextRetry = retryCount + 1;
        
        
        const retryTimer = setTimeout(() => {
          setRetryCount(nextRetry);
        }, 1000);
        
        return () => clearTimeout(retryTimer);
      }
      
      return;
    }

    
    
    const fetchData = async () => {
      window.visualLogger?.log('Carregando dados iniciais...');
      
      
      try {
        // A lista de pacientes não depende da empresa nem dos modelos: pede já, em
        // paralelo, e só espera por ela no fim (PERF-01). O catch vazio evita o aviso de
        // rejeição sem tratamento; o await lá embaixo repassa o erro ao catch de fora.
        const patientsPromise = new Promise((resolve, reject) => {
          GetPatientsAPI(companyId, (result) => {
            if (!result) {
              window.visualLogger?.error('Erro ao carregar lista de pacientes');
              reject(new Error('Erro ao carregar lista de pacientes'));
              return;
            }
            resolve(result);
          });
        });
        patientsPromise.catch(() => {});

        // Load company data
        const companyData = await new Promise((resolve, reject) => {
          
          GetCompanyConfigAPI(companyId, (result) => {
            if (!result || result.error) {
              window.visualLogger?.error('Erro ao carregar dados da empresa');
              reject(new Error(result?.error || 'Erro ao carregar dados da empresa'));
              return;
            }

            let data = {};
            try {
              // Process company data
              data.Id = result.id;
              data.CNPJ = result.cnpj;
              data.Logo = result.logo;
              data.Banner = result.banner;
              data.Name = result.name;
              data.Phone = result.phone;
              data.countryCode = result.countryCode || '';
              data.Email = result.email;
              data.Cep = result.cep;
              data.District = result.district;
              data.City = result.city;
              data.State = result.state;
              data.Country = result.country;
              data.Address = result.address;
              data.Number = result.number;
              data.Complement = result.complement;
              data.AvailableDaysOfWeek = JSON.parse(result.availableDaysOfWeek);
              data.AvailableTime = JSON.parse(result.availableTime);
              data.BlockedTimes = JSON.parse(result.blockedTimes);
              data.TargetOccupation = JSON.parse(result.targetOccupation);
              data.TimeInterval = JSON.parse(result.timeInterval);
              data.GoalAppointments = JSON.parse(result.goalAppointments);
              data.GoalBilling = JSON.parse(result.goalBilling);
              data.Resources = result.resources;
              data.Procedures = result.procedures;
              data.Rooms = result.rooms;
              data.InsuranceProviders = result.insuranceProviders || [];
              data.PaymentOptions = result.paymentOptions;
              data.PatientOrigins = result.patientOrigins;
              data.PatientComplaints = result.patientComplaints;
              data.DocumentTemplates = result.documentTemplates;
              data.AnamneseTemplates = result.anamneseTemplates;
              data.AppointmentTypes = result.appointmentTypes || [];
              data.AppointmentSteps = result.appointmentSteps || [];
              data.AppointmentStatusColors = result.appointmentStatusColors || {};
              setStatusColorOverrides(data.AppointmentStatusColors);
              data.MessageTemplates = result.messageTemplates || [];
              data.LeadsSources = result.leadsSources || [];
              data.LeadsCampaigns = result.leadsCampaigns || [];
              // Public schedule settings
              data.public_schedule_enabled = result.public_schedule_enabled;
              data.public_schedule_slug = result.public_schedule_slug || '';
              data.public_schedule_whatsapp = result.public_schedule_whatsapp || '';
              // Dados de exemplo da conta em teste: { seeded_at, removed_at, reason, active }
              data.DemoData = result.demo_data || null;
              
              setCompanyConfig(data);
              resolve(data);
            } catch (e) {
              window.visualLogger?.error('Erro ao processar dados da empresa');
              reject(e);
            }
          });
        });

        window.visualLogger?.log('Carregando templates de mensagens...');
        
        // Load message templates
        await new Promise((resolve, reject) => {
          
          
          GetCompanyMessageTemplatesAPI(companyId, (response) => {
            
            
            // Update the separate messageTemplates state
            setMessageTemplates(response || []);
            
            
            // Also update the CompanyConfig for backward compatibility
            setCompanyConfig(prevConfig => {
              
              const updatedConfig = {
                ...prevConfig,
                MessageTemplates: response || [] // Ensure we always have an array
              };
              
              return updatedConfig;
            });
            
            resolve();
          });
        });

        window.visualLogger?.log('Carregando lista de pacientes...');
        
        // Load patients (pedida lá em cima, em paralelo com a empresa e os modelos)
        SetPatients(await patientsPromise);
        setPatientsLoadedAt(Date.now());

        window.visualLogger?.log('Dados carregados com sucesso');

        loadedCompanyIdRef.current = companyId;
        OnComplete();
        setIsUpdating(false);
        
        // Reset retry count on success
        setRetryCount(0);
        
        // Dispatch event for testing
        window.dispatchEvent(new CustomEvent('dataProviderComplete'));
      } catch (error) {
        window.visualLogger?.error('Erro ao carregar dados: ' + error.message);
        
        
        // If we haven't reached max retries, set up a retry
        if (retryCount < maxRetries) {
          const nextRetry = retryCount + 1;
          
          
          setTimeout(() => {
            setRetryCount(nextRetry);
          }, 2000);
        }
        
        setIsUpdating(false);
      }
    };

    fetchData();
  }, [companyId, retryCount]);

  const SetAppointmentInvoice = async (appointmentId, patient, price, paymentMethod, procedure, issueDocument, callback) => {
    setIsUpdating(true);

    const createdBy = currentSession?.user?.id;

    SetAppointmentInvoiceAPI(appointmentId, companyId, createdBy, patient, price, paymentMethod, procedure, issueDocument, (response) => {
      GetAppointments();
      callback(response);
    });
  }

  const UpdateInvoice = async (invoiceId, price, paymentMethod, issueDocument, callback) => {
    const updatedBy = currentSession?.user?.id;

    UpdateInvoiceAPI(invoiceId, price, paymentMethod, issueDocument, updatedBy, (response) => {
      callback(response);
    });
  }

  const UpdateInvoiceNfIssued = async (invoiceId, issueDocument, callback) => {
    const updatedBy = currentSession?.user?.id;
    UpdateInvoiceNfIssuedAPI(invoiceId, issueDocument, updatedBy, (response) => {
      callback(response);
    });
  }

  const DeleteInvoice = async (invoiceId, callback) => {
    // Sem recarga aqui: quem exclui (drawer da agenda, CreateInvoicePopup) já recarrega
    // a agenda no próprio retorno; recarregar aqui também dobrava a chamada
    DeleteInvoiceAPI(companyId, invoiceId, (response) => {
      if(callback) callback(response);
    });
  }

  const GetInvoice = async (id, callback) => {
    GetInvoiceAPI(id, (response) => {
      callback(response);
    });
  }

  const UpdateCompanyConfig = async (data, callback) => {
    setIsUpdating(true);
    UpdateCompanyConfigAPI(companyId, data, (result) => {
      GetCompany((result) => {
        setIsUpdating(false);
        callback(result);
      });
    });
  }

  const UpdateCompany = async (data, callback) => {
    
    setIsUpdating(true);

    UpdateCompanyAPI(companyId, data, (result) => {
      GetCompany((result) => {
        setIsUpdating(false);
        callback(result);
      });
    });
  }

  const GetCompany = async (callback) => {

    GetCompanyConfigAPI(companyId, (result) => {
      let data = {};

      data.Id = result.id;
      data.CNPJ = result.cnpj;
      data.Logo = result.logo;
      data.Banner = result.banner;

      data.Name = result.name;

      data.Phone = result.phone;
      data.countryCode = result.countryCode || '';
      data.Email = result.email;

      data.Cep = result.cep;
      data.District = result.district;
      data.City = result.city;
      data.State = result.state;
      data.Country = result.country;
      data.Address = result.address;
      data.Number = result.number;
      data.Complement = result.complement;

      data.AvailableDaysOfWeek = JSON.parse(result.availableDaysOfWeek);
      data.AvailableTime = JSON.parse(result.availableTime);
      data.BlockedTimes = JSON.parse(result.blockedTimes);
      
      data.TargetOccupation = JSON.parse(result.targetOccupation);
      data.TimeInterval = JSON.parse(result.timeInterval);
      data.GoalAppointments = JSON.parse(result.goalAppointments);
      data.GoalBilling = JSON.parse(result.goalBilling);
      data.Resources = result.resources;
      data.Procedures = result.procedures;
      data.Rooms = result.rooms;
      data.InsuranceProviders = result.insuranceProviders || [];
      data.PaymentOptions = result.paymentOptions;
      data.PatientOrigins = result.patientOrigins;

      data.PatientComplaints = result.patientComplaints;
      data.DocumentTemplates = result.documentTemplates;
      data.AnamneseTemplates = result.anamneseTemplates;
      data.AppointmentTypes = result.appointmentTypes || [];
      data.AppointmentSteps = result.appointmentSteps || [];
      data.AppointmentStatusColors = result.appointmentStatusColors || {};
      setStatusColorOverrides(data.AppointmentStatusColors);
      data.MessageTemplates = result.messageTemplates || [];

      data.LeadsSources = result.leadsSources || [];
      data.LeadsCampaigns = result.leadsCampaigns || [];
      // Public schedule settings
      data.public_schedule_enabled = result.public_schedule_enabled;
      data.public_schedule_slug = result.public_schedule_slug || '';
      data.public_schedule_whatsapp = result.public_schedule_whatsapp || '';
      // Dados de exemplo da conta em teste: { seeded_at, removed_at, reason, active }
      data.DemoData = result.demo_data || null;

      setCompanyConfig(data);

      if(callback) callback(data);
    });
  };

  const GetCEPInfo = (cep, callback) => {
    GetCEPInfoAPI(cep, (result) => {
      callback(result);
    });
  }

  const GetPatients = async (dispatchUpdatingEvent = true, callback) => {
    if (dispatchUpdatingEvent) setIsUpdating(true);
    GetPatientsAPI(companyId, (result) => {
      SetPatients(result);
      setPatientsLoadedAt(Date.now());
      if (callback) callback(result);
      if (dispatchUpdatingEvent) setIsUpdating(false);
    });
  };

  const GetPatientById = (id) => patientsById.get(String(id));

  const SetPatient = async (data, callback) => {

    const createdBy = currentSession?.user?.id;
    const hadNoPatientsBeforeCreate = patients.length === 0;

    SetPatientAPI(companyId, createdBy, data, (response) => {
      if (response && !response.error) {
        trackFirstEntityCreatedOnce('patient', companyId, hadNoPatientsBeforeCreate);
      }
      if(callback) callback(response);
      GetPatients(false);
    });
  }

  const UpdatePatient = async (data, callback) => {
    UpdatePatientAPI(data, () => {
      GetPatients();
      if(callback) callback();
    });
  }


  // Último período carregado: recargas sem datas (depois de faturar ou excluir
  // fatura) reaproveitam esse período em vez de pedir a agenda inteira, que numa
  // conta grande são dezenas de milhares de linhas
  const lastAppointmentsRangeRef = useRef(null);
  const lastAppointmentsRef = useRef([]);

  const GetAppointments = async (startDate, endDate, callback) => {

    if (!startDate && !endDate) {
      if (!lastAppointmentsRangeRef.current) return;
      ({ startDate, endDate } = lastAppointmentsRangeRef.current);
    } else {
      lastAppointmentsRangeRef.current = { startDate, endDate };
    }

    GetAppointmentsAPI(companyId, startDate, endDate, (result) => {

      // Resposta de erro nunca vira a lista: a agenda segue com o que já tinha
      if (!Array.isArray(result)) {
        window.visualLogger?.error('Erro ao carregar agendamentos: ' + (result?.error || result?.message || 'resposta inválida'));
        if (callback) callback(lastAppointmentsRef.current);
        return;
      }

      lastAppointmentsRef.current = result;
      setAppointments(result);
      
      if(callback)
      {
        callback(result);
      }
    });
  };


  const SetAppointment = async (data, callback) => {

    const createdBy = currentSession?.user?.id;
    const hadNoAppointmentsBeforeCreate = appointments.length === 0;

    SetAppointmentAPI(companyId, createdBy, data, (response) => {

      if (response && !response.error) {
        trackFirstEntityCreatedOnce('appointment', companyId, hadNoAppointmentsBeforeCreate);
      }

      if (callback != undefined) {
        callback(response);
      }
    });
  }

  /**
   * Calcula as ocorrências de uma recorrência semanal e a disponibilidade de cada uma.
   * Não cria nada: serve apenas para a etapa de revisão.
   */
  const PreviewRecurringAppointments = async (params, callback) => {
    PreviewRecurringAppointmentsAPI(params, (response) => {
      if (callback) callback(response);
    });
  }

  /**
   * Cria em lote os agendamentos aprovados na revisão da recorrência.
   * Cada item gera um agendamento individual e independente.
   */
  const CreateRecurringAppointments = async (data, items, callback) => {
    const createdBy = currentSession?.user?.id;

    CreateRecurringAppointmentsAPI(companyId, createdBy, data, items, (response) => {
      if (callback) callback(response);
    });
  }

  const UpdateAppointment = async (data, callback) => {
    UpdateAppointmentAPI(data, (response) => {
      if(callback) callback(response);
    });
  }

  const DeleteAppointment = async (id, callback) => {
    DeleteAppointmentAPI(id, () => {
      if(callback) callback();
    });
  }

  const GetLeads = async (callback) => {
    GetLeadsAPI(companyId, (response) => {
      if(callback) callback(response);
    });
  }

  const FindLeadByPhone = async (countryCode, phone, callback) => {
    FindLeadByPhoneAPI(countryCode, phone, (response) => {
      if(callback) callback(response);
    });
  }

  const SetLead = async (data, callback) => {

    const createdBy = userData.id;
      
   SetLeadAPI(createdBy, data, (response) => {
        if(callback) callback(response);
      });
  }

  const UpdateLead = async (data, callback) => {

    const updatedBy = currentSession?.user?.id;

    UpdateLeadAPI(updatedBy, data, (response) => {
      if(callback) callback(response);
    });

  }

  const DeleteLead = async (id, callback) => {
    DeleteLeadAPI(id, (response) => {
      if(callback) callback(response);
    });
  }

  const GetCampaigns = async (callback) => {
    GetCampaignsAPI(companyId, (response) => {
      if (response.status == "success") {
        syncLeadsCampaignsState(response.data || []);
      }
      if(callback) callback(response);
    });
  }

  const SetCampaign = async (data, callback) => {
    const createdBy = userData.id;

    SetCampaignAPI(companyId, createdBy, data, (response) => {
      if (response.status == "success") {
        GetCampaigns(() => {
          if(callback) callback(response);
        });
      } else {
        if(callback) callback(response);
      }
    });
  }

  const UpdateCampaign = async (data, callback) => {
    const updatedBy = userData.id;

    UpdateCampaignAPI(companyId, updatedBy, data, (response) => {
      if (response.status == "success") {
        GetCampaigns(() => {
          if(callback) callback(response);
        });
      } else {
        if(callback) callback(response);
      }
    });
  }

  const DeleteCampaign = async (id, callback) => {
    DeleteCampaignAPI(companyId, id, (response) => {
      if (response.status == "success") {
        GetCampaigns(() => {
          if(callback) callback(response);
        });
      } else {
        if(callback) callback(response);
      }
    });
  }

  const GetMarketingCampaignsByChannel = async (sourceId, callback) => {
    GetCampaignsBySourceAPI(companyId, sourceId, (response) => {
      if(callback) callback(response);
    });
  }

  const GetMarketingChannels = async (callback) => {
    GetSourcesAPI(companyId, (response) => {
      if (response.status == "success") {
        syncLeadsSourcesState(response.data || []);
      }
      if(callback) callback(response);
    });
  }

  const SetMarketingChannel = async (data, callback) => {
    const createdBy = userData.id;
    
    SetSourceAPI(companyId, createdBy, data, (response) => {
      if (response.status == "success") {
        GetMarketingChannels(() => {
          if(callback) callback(response);
        });
      } else {
        if(callback) callback(response);
      }
    });
  }

  const UpdateMarketingChannel = async (data, callback) => {
    const updatedBy = userData.id;
    
    UpdateSourceAPI(companyId, updatedBy, data, (response) => {
      if (response.status == "success") {
        GetMarketingChannels(() => {
          if(callback) callback(response);
        });
      } else {
        if(callback) callback(response);
      }
    });
  }

  const DeleteMarketingChannel = async (id, callback) => {
    DeleteSourceAPI(companyId, id, (response) => {
      if (response.status == "success") {
        GetMarketingChannels(() => {
          if(callback) callback(response);
        });
      } else {
        if(callback) callback(response);
      }
    });
  }

  const syncDocumentTemplatesState = async (templates) => {
    setCompanyConfig(prevConfig => ({
      ...prevConfig,
      DocumentTemplates: templates
    }));
  };

  const GetTemplatesDocuments = async (callback) => {
    GetTemplatesDocumentsAPI(companyId, (response) => {
      // Atualiza o estado interno do DataProvider com os templates mais recentes
      syncDocumentTemplatesState(response);
      if(callback) callback(response);
    });
  }

  const SetTemplatesDocuments = async (data, callback) => {
    const createdBy = userData.id;

    SetTemplatesDocumentsAPI(companyId, createdBy, data, (response) => {
      GetTemplatesDocumentsAPI(companyId, (templates) => {
        syncDocumentTemplatesState(templates);
        if(callback) callback(response);
      });
    });
  }

  const UpdateTemplatesDocuments = async (data, callback) => {
    const updatedBy = userData.id;

    UpdateTemplatesDocumentsAPI(companyId, updatedBy, data, (response) => {
      GetTemplatesDocumentsAPI(companyId, (templates) => {
        syncDocumentTemplatesState(templates);
        if(callback) callback(response);
      });
    });
  }

  const DeleteTemplatesDocuments = async (id, callback) => {
    DeleteTemplatesDocumentsAPI(id, (response) => {
      GetTemplatesDocumentsAPI(companyId, (templates) => {
        syncDocumentTemplatesState(templates);
        if(callback) callback(response);
      });
    });
  }

  const GetMessageTemplates = async (callback) => {
    
    // Sempre buscar os templates mais recentes do servidor
    return new Promise((resolve, reject) => {
      try {
        GetCompanyMessageTemplatesAPI(companyId, async (response) => {
          
          
          // Update both states
          setMessageTemplates(response || []);
          await syncCompanyMessageTemplatesState(response || []);
          
          
          
          if(callback) {
            
            callback(response || []);
          }
          resolve(response || []);
        });
      } catch (error) {
        
        // Still update state with empty array to ensure consistency
        setMessageTemplates([]);
        syncCompanyMessageTemplatesState([]);
        if(callback) callback([]);
        resolve([]);
      }
    });
  }

  const UpdateMessageTemplate = async (id, template_content, callback) => {
    
    
    UpdateCompanyMessageTemplateAPI(companyId, id, template_content, (response) => {
      
      
      // Refresh templates from the server
      GetCompanyMessageTemplatesAPI(companyId, (templates) => {
        
        
        // Update both states
        setMessageTemplates(templates || []);
        syncCompanyMessageTemplatesState(templates);
        
        if(callback) callback(response);
      });
    });
  }

  const GetDashboard = async (data) => {
    GetDashboardAPI(companyId, data, () => {
    });
  }

  const GetAppointmentsKpi = async (startDate, endDate, callback) => {
    GetAppointmentsKpiAPI(startDate, endDate, (result) => {
      if (callback) callback(result);
    });
  }

  const GetReportsAppointments = async (startDate, endDate, callback) => {
    GetReportsAppointmentsAPI(companyId, startDate, endDate,callback);
  }

  const GetReportsFinancial = async (startDate, endDate, callback) => {
    GetReportsFinancialAPI(companyId, startDate, endDate, callback);
  }

  function GetProcedureById(id) {
    return CompanyConfig.Procedures.find(p => p.Id == id);
  }

  function GetResourceById(id) {
    return CompanyConfig.Resources.find(p => p.Id == id);
  }

  const SetPatientAnamnese = async (currentDate, patientId, appointmentId, json, template, callback) => {
    const createdBy = userData.id;

    SetPatientAnamneseAPI(currentDate, createdBy, patientId, appointmentId, json, template, (response) => {
      callback(response);
    });
  };

  const UpdatePatientAnamnese = async (id, patientId, json, callback) => {
    const updatedBy = userData.id;

    UpdatePatientAnamneseAPI(id, patientId, json, updatedBy, (response) => {
      callback(response);
    });
  };

  const DeletePatientAnamnese = async (id, callback) => {
    const deletedBy = userData.id;

    DeletePatientAnamneseAPI(id, deletedBy, (response) => {
      callback(response);
    });
  };

  const SetPatientHistory = async (currentDate, patientId, appointmentId, assessment, evolution, callback) => {

    const createdBy = userData.id;

    SetPatientHistoryAPI(currentDate, createdBy, patientId, appointmentId, assessment, evolution, (response) => {
      callback(response);
    });
  };

  const SetPatientNote = async (patientId, appointmentId, note, callback) => {
    const createdBy = userData.id;

    SetPatientNoteAPI(patientId, appointmentId, note, createdBy, (response) => {
      callback(response);
    });
  };

  const AnnulPatientHistoryRecord = async (recordId, patientId, annulReason, callback) => {
    const annulledBy = userData.id;

    AnnulPatientHistoryRecordAPI(recordId, patientId, annulledBy, annulReason, (response) => {
      callback(response);
    });
  };

  const CreateReplacementHistoryRecord = async (originalRecordId, patientId, assessment, evolution, callback) => {
    const createdBy = userData.id;

    CreateReplacementHistoryRecordAPI(originalRecordId, patientId, assessment, evolution, createdBy, (response) => {
      callback(response);
    });
  };

  const SetPatientCranialAsymmetry = async (currentDate, patientId, appointmentId, ab, bp, dd, de, callback) => {
    const createdBy = userData.id;

    SetPatientCranialAsymmetryAPI(currentDate, createdBy, patientId, appointmentId, ab, bp, dd, de, (response) => {
      callback(response);
    });
  }

  const UpdatePatientCranialAsymmetry = async (id, currentDate, patientId, appointmentId, ap, bp, dd, de, callback) => {
    UpdatePatientCranialAsymmetryAPI(id, currentDate, patientId, appointmentId, ap, bp, dd, de, (response) => {
      callback(response);
    });
  }

  const DeletePatientCranialAsymmetry = async (id, callback) => {
    DeletePatientCranialAsymmetryAPI(id, (response) => {
      callback(response);
    });
  }

  /**
   * Envia um anexo do paciente. `data` é um objeto simples; os arquivos vêm em
   * data.file (obrigatório) e data.thumb (opcional, só imagens). O FormData é
   * montado aqui para que os componentes não precisem conhecê-lo.
   */
  const UploadPatientAttachment = async (data, callback, errorCallback = null) => {
    const createdBy = userData.id;

    const formData = new FormData();

    formData.append('patientId', data.patientId);
    formData.append('context', data.context || 'general');
    formData.append('documentDate', data.documentDate);
    formData.append('createdBy', createdBy);

    if (data.appointmentId) formData.append('appointmentId', data.appointmentId);
    if (data.contextId) formData.append('contextId', data.contextId);
    if (data.category) formData.append('category', data.category);
    if (data.title) formData.append('title', data.title);
    if (data.note) formData.append('note', data.note);
    if (data.width) formData.append('width', data.width);
    if (data.height) formData.append('height', data.height);
    if (data.meta) formData.append('meta', typeof data.meta === 'string' ? data.meta : JSON.stringify(data.meta));

    formData.append('file', data.file, data.fileName || (data.file && data.file.name) || 'arquivo');

    if (data.thumb) {
      formData.append('thumb', data.thumb, 'thumb.jpg');
    }

    UploadPatientAttachmentAPI(formData, (response) => {
      callback(response);
    }, errorCallback);
  };

  // Medidas corporais (módulo "Medidas corporais")
  const SetPatientBodyMeasurements = async (patientId, appointmentId, data, callback) => {
    SetPatientBodyMeasurementsAPI(patientId, appointmentId, data, userData.id, (response) => {
      callback(response);
    });
  };

  const UpdatePatientBodyMeasurements = async (id, data, callback) => {
    UpdatePatientBodyMeasurementsAPI(id, data, userData.id, (response) => {
      callback(response);
    });
  };

  const DeletePatientBodyMeasurements = async (id, callback) => {
    DeletePatientBodyMeasurementsAPI(id, (response) => {
      callback(response);
    });
  };

  // Mapa corporal (módulo "Mapa corporal"): grava a lista inteira de marcadores do atendimento
  const SetPatientBodyMap = async (patientId, appointmentId, markers, callback) => {
    SetPatientBodyMapAPI(patientId, appointmentId, markers, userData.id, (response) => {
      callback(response);
    });
  };

  // Escalas clínicas (módulos de escala): grava a resposta de uma escala no atendimento
  const SetPatientScaleAssessment = async (patientId, appointmentId, scaleKey, value, callback) => {
    SetPatientScaleAssessmentAPI(patientId, appointmentId, scaleKey, value, userData.id, (response) => {
      callback(response);
    });
  };

  // Curva de crescimento: cria (ou, com data.id, altera) uma medição do paciente
  const SetPatientGrowthMeasurement = async (patientId, appointmentId, data, callback) => {
    SetPatientGrowthMeasurementAPI(patientId, appointmentId, data, userData.id, (response) => {
      callback(response);
    });
  };

  const DeletePatientGrowthMeasurement = async (id, callback) => {
    DeletePatientGrowthMeasurementAPI(id, (response) => {
      callback(response);
    });
  };

  // Marcos motores: registra (ou altera) a conquista de um marco do paciente
  const SetPatientMotorMilestone = async (patientId, appointmentId, data, callback) => {
    SetPatientMotorMilestoneAPI(patientId, appointmentId, data, userData.id, (response) => {
      callback(response);
    });
  };

  const DeletePatientMotorMilestone = async (id, callback) => {
    DeletePatientMotorMilestoneAPI(id, (response) => {
      callback(response);
    });
  };

  // Termografia: grava (ou altera) a avaliação termográfica do atendimento
  const SetPatientThermography = async (patientId, appointmentId, data, callback) => {
    SetPatientThermographyAPI(patientId, appointmentId, data, userData.id, (response) => {
      callback(response);
    });
  };

  const DeletePatientThermography = async (id, callback) => {
    DeletePatientThermographyAPI(id, (response) => {
      callback(response);
    });
  };

  // Escala motora de Alberta: grava (ou altera) a avaliação do atendimento
  const SetPatientAimsAssessment = async (patientId, appointmentId, data, callback) => {
    SetPatientAimsAssessmentAPI(patientId, appointmentId, data, userData.id, (response) => {
      callback(response);
    });
  };

  const DeletePatientAimsAssessment = async (id, callback) => {
    DeletePatientAimsAssessmentAPI(id, (response) => {
      callback(response);
    });
  };

  const SetPatientBirthInfo = async (patientId, data, callback) => {
    SetPatientBirthInfoAPI(patientId, data, userData.id, (response) => {
      callback(response);
    });
  };

  // Receituário: receitas do atendimento e modelos da clínica
  const SetPatientPrescription = async (patientId, appointmentId, data, callback) => {
    SetPatientPrescriptionAPI(patientId, appointmentId, data, userData.id, (response) => {
      callback(response);
    });
  };

  const DeletePatientPrescription = async (id, callback) => {
    DeletePatientPrescriptionAPI(id, (response) => {
      callback(response);
    });
  };

  const SetPrescriptionTemplate = async (data, callback) => {
    SetPrescriptionTemplateAPI(data, userData.id, (response) => {
      callback(response);
    });
  };

  const DeletePrescriptionTemplate = async (id, callback) => {
    DeletePrescriptionTemplateAPI(id, (response) => {
      callback(response);
    });
  };

  // Diagnósticos CID-10 e CID-11
  const SearchIcd = async (classification, query, callback) => {
    SearchIcdAPI(classification, query, (response) => {
      callback(response);
    });
  };

  const SetPatientDiagnosis = async (patientId, appointmentId, classification, code, callback) => {
    SetPatientDiagnosisAPI(patientId, appointmentId, classification, code, userData.id, (response) => {
      callback(response);
    });
  };

  const DeletePatientDiagnosis = async (id, callback) => {
    DeletePatientDiagnosisAPI(id, (response) => {
      callback(response);
    });
  };

  const SetPatientMealPlan = async (patientId, appointmentId, data, callback) => {
    SetPatientMealPlanAPI(patientId, appointmentId, data, userData.id, (response) => {
      callback(response);
    });
  };

  const UpdatePatientMealPlan = async (id, data, callback) => {
    UpdatePatientMealPlanAPI(id, data, userData.id, (response) => {
      callback(response);
    });
  };

  const DeletePatientMealPlan = async (id, callback) => {
    DeletePatientMealPlanAPI(id, (response) => {
      callback(response);
    });
  };

  // Mapa de aplicação (módulo "Mapa de aplicação"): grava marcações, lote e observações do atendimento
  const SetPatientApplicationMap = async (patientId, appointmentId, data, callback) => {
    SetPatientApplicationMapAPI(patientId, appointmentId, data, userData.id, (response) => {
      callback(response);
    });
  };

  const SetApplicationProducts = async (products, callback) => {
    SetApplicationProductsAPI(products, (response) => {
      callback(response);
    });
  };

  const CreatePatientRegistrationLink = async (callback) => {
    CreatePatientRegistrationLinkAPI((response) => {
      callback(response);
    });
  };

  const SendPatientRegistrationLinkWhatsApp = (token, countryCode, phone, callback) => {
    SendPatientRegistrationLinkWhatsAppAPI(token, countryCode, phone, (response) => {
      callback(response);
    });
  };

  const SetPatientRegistrationLinkOrigin = (token, originChannelId, originCampaignId, callback) => {
    SetPatientRegistrationLinkOriginAPI(token, originChannelId, originCampaignId, (response) => {
      callback(response);
    });
  };

  const CreateAppointmentReservation = (reservation, callback) => {
    CreateAppointmentReservationAPI(reservation, (response) => {
      callback(response);
    });
  };

  const GetAppointmentReservation = (appointmentId, callback) => {
    GetAppointmentReservationAPI(appointmentId, (response) => {
      callback(response);
    });
  };

  const ResendAppointmentReservation = (appointmentId, callback) => {
    ResendAppointmentReservationAPI(appointmentId, (response) => {
      callback(response);
    });
  };

  const NotifyReleasedAppointmentReservation = (appointmentId, callback) => {
    NotifyReleasedAppointmentReservationAPI(appointmentId, (response) => {
      callback(response);
    });
  };

  /**
   * Sends the prepared analysis copy to the experimental cranial analysis
   * endpoint. Nothing is persisted; the response carries the AI suggestion
   * or { success: false, code, error } (also for non-200 HTTP statuses).
   */
  const AnalyzeCranialImage = async (data, callback, errorCallback = null) => {
    const formData = new FormData();

    formData.append('image', data.image, 'analysis.jpg');
    formData.append('analysisWidth', data.analysisWidth);
    formData.append('analysisHeight', data.analysisHeight);

    AnalyzeCranialImageAPI(formData, (response) => {
      callback(response);
    }, errorCallback);
  };

  const ListPatientAttachments = async (patientId, context, callback) => {
    ListPatientAttachmentsAPI(patientId, context, (response) => {
      callback(response);
    });
  };

  const UpdatePatientAttachment = async (fields, callback) => {
    UpdatePatientAttachmentAPI(fields, (response) => {
      callback(response);
    });
  };

  const DeletePatientAttachment = async (id, callback) => {
    DeletePatientAttachmentAPI(id, (response) => {
      callback(response);
    });
  };

  // Devolve uma Promise<Blob> com o arquivo do anexo (thumb ou full).
  const GetPatientAttachmentFile = (id, size = 'full') => {
    return GetPatientAttachmentFileAPI(id, size);
  };

  const SetPatientDocument = async (patientId, date, appointmentId, title, description, callback) => {

    const createdBy = userData.id;

    SetPatientDocumentAPI(patientId, date, appointmentId, title, description, createdBy, (response) => {
      callback(response);
    });
  };

  const GetWaitingList = async (params, callback) => {
    // Ensure companyId is set
    params.companyId = params.companyId || companyId;
    GetWaitingListAPI(params, callback);
  }

  const SetWaitingList = async (data, callback) => {
    const createdBy = userData.id;
    SetWaitingListAPI(companyId, createdBy, data, callback);
  }

  const UpdateWaitingList = async (data, callback) => {
    const updatedBy = userData.id;
    UpdateWaitingListAPI(updatedBy, data, callback);
  }

  const DeleteWaitingList = async (id, callback) => {
    DeleteWaitingListAPI(id, callback);
  }

  const CheckWaitingListAvailability = async (params, callback) => {
    // Ensure companyId is set
    params.companyId = params.companyId || companyId;
    CheckWaitingListAvailabilityAPI(params, callback);
  }

  // Waiting List Offers
  const GetWaitingListOffers = async (params, callback) => {
    GetWaitingListOffersAPI(params || {}, callback);
  }

  const SetWaitingListOffer = async (data, callback) => {
    const createdBy = userData.id;
    SetWaitingListOfferAPI({ ...data, createdBy }, callback);
  }

  const UpdateWaitingListOffer = async (data, callback) => {
    UpdateWaitingListOfferAPI(data, callback);
  }

  const SendWhatsappMessage = async (to, text, delay, callback) => {
    SendWhatsappMessageAPI(companyId, to, text, delay, (result) => {
      if(callback) callback(result);
    });
  }

  const SendWhatsappDocument = async (phone, document, fileName, caption, countryCode, callback) => {
    SendWhatsappDocumentAPI(companyId, phone, document, fileName, caption, countryCode || '', (result) => {
      if (callback) callback(result);
    });
  }

  const GetWhatsappChats = async (callback) => {
    GetWhatsappChatsAPI(companyId, (result) => {
      if(callback) callback(result);
    });
  }
 
  // options: { sinceId, beforeId, limit } — cursores de paginação/polling (opcional)
  const GetWhatsappChatMessages = async (chatId, options, callback) => {
    if (typeof options === 'function') {
      callback = options;
      options = {};
    }
    GetWhatsappChatMessagesAPI(companyId, chatId, options, (result) => {
      if(callback)  callback(result);
    });
  }

  const SetWhatsappChatRead = async (chatId, callback) => {
    SetWhatsappChatReadAPI(companyId, chatId, (result) => {
      if(callback) callback(result);
    });
  }

  // Contexto do contato da conversa: paciente, lead ou sem vínculo
  const GetWhatsappContactContext = async (phone, callback) => {
    GetWhatsappContactContextAPI(companyId, phone, (result) => {
      if(callback) callback(result);
    });
  }

  // Sugestão de resposta por IA para a conversa aberta (modo copiloto)
  const GetWhatsappAISuggestion = async (chatKey, phone, callback) => {
    GetWhatsappAISuggestionAPI(chatKey, phone, (result) => {
      if(callback) callback(result);
    });
  }

  const SetWhatsappAISuggestionOutcome = async (suggestionId, outcome, sentText, callback) => {
    SetWhatsappAISuggestionOutcomeAPI(suggestionId, outcome, sentText, (result) => {
      if(callback) callback(result);
    });
  }

  const GetWhatsappConfig = async (callback) => {
    GetWhatsappConfigAPI(companyId, (result) => {
      if(callback) callback(result);
    });
  }

  const SetWhatsappConfig = async (instanceId, instanceToken, securityToken, isActive, saveMessages, callback) => {
    SetWhatsappConfigAPI(companyId, instanceId, instanceToken, securityToken, isActive, saveMessages, (result) => {
      if(callback) callback(result);
    });
  }

  const TestWhatsappConfig = async (callback) => {
    TestWhatsappConfigAPI(companyId, (result) => {
      if(callback) callback(result);
    });
  }

  /**
   * Aviso da agenda ao paciente pelo sistema (agendamento criado, reagendado,
   * oferta de horário), na hora, em vez de abrir o WhatsApp Web.
   */
  const NotifyAppointmentPatientWhatsApp = async (payload, callback) => {
    NotifyAppointmentPatientWhatsAppAPI(payload, (result) => {
      if (callback) callback(result);
    });
  }

  const GetWhatsappSenderStatus = async (callback) => {
    GetWhatsappSenderStatusAPI(companyId, (result) => {
      if(callback) callback(result);
    });
  }

  const SetWhatsappSenderToggles = async ({ useOwnNumber, allowPlatformFallback } = {}, callback) => {
    SetWhatsappSenderTogglesAPI(companyId, { useOwnNumber, allowPlatformFallback }, (result) => {
      if(callback) callback(result);
    });
  }

  const GetWhatsappDeviceInfo = async (callback) => {
    GetWhatsappDeviceInfoAPI(companyId, (result) => {
      if(callback) callback(result);
    });
  }

  const GetWhatsappQRCode = async (callback) => {
    GetWhatsappQRCodeAPI(companyId, (result) => {
      if(callback) callback(result);
    });
  }

  const GetWhatsappPhoneCode = async (phone, callback) => {
    GetWhatsappPhoneCodeAPI(companyId, phone, (result) => {
      if(callback) callback(result);
    });
  }

  const DisconnectWhatsapp = async (callback) => {
    DisconnectWhatsappAPI(companyId, (result) => {
      if(callback) callback(result);
    });
  }

  // AI Patient Response Engine (Simulador de Atendimento)
  // messages: [{ role: 'patient' | 'ai', content: string }, ...]
  // knowledge: texto livre com FAQs/políticas/instruções da clínica (opcional)
  const GenerateAISimulatorReply = async (messages, knowledge, callback) => {
    GenerateAISimulatorReplyAPI(messages, knowledge, (result) => {
      if(callback) callback(result);
    });
  }

  // Configuração da atendente virtual (AI Patient Response Engine)
  const GetAISettings = async (callback) => {
    GetAISettingsAPI((result) => {
      if(callback) callback(result);
    });
  }

  const SetAISettings = async (settings, callback) => {
    SetAISettingsAPI(settings, (result) => {
      if(callback) callback(result);
    });
  }

  const GetNPSResponses = async (startDate, endDate, category, callback) => {
    return new Promise((resolve) => {
      GetNPSResponsesAPI(companyId, startDate, endDate, category, (result) => {
        if(callback) callback(result);
        resolve(result);
      });
    });
  }

  const SetNPSResponse = async (patientId, appointmentId, score, comments, callback) => {
    SetNPSResponseAPI(companyId, patientId, appointmentId, score, comments, (result) => {
      if(callback) callback(result);
    });
  }

  const UpdateNPSGoogleReview = async (reviewId, status, callback) => {
    UpdateNPSGoogleReviewAPI(companyId, reviewId, status, (result) => {
      if(callback) callback(result);
    });
  }

  const PrepareManualNPSMessage = async (appointmentId, callback) => {
    return new Promise((resolve) => {
      PrepareManualNPSMessageAPI(appointmentId, (result) => {
        if(callback) callback(result);
        resolve(result);
      });
    });
  }

  const GetGoogleReviewSuggestions = async (startDate, endDate, status, callback) => {
    return new Promise((resolve) => {
      GetGoogleReviewSuggestionsAPI(companyId, startDate, endDate, status, (result) => {
        if(callback) callback(result);
        resolve(result);
      });
    });
  }

  // Financial Categories
  const GetFinancialCategories = async (callback) => {
    GetFinancialCategoriesAPI(companyId, (result) => {
      if(callback) callback(result);
    });
  }

  const SetFinancialCategory = async (data, callback) => {
    SetFinancialCategoryAPI(companyId, data, (result) => {
      if(callback) callback(result);
    });
  }

  const UpdateFinancialCategory = async (data, callback) => {
    UpdateFinancialCategoryAPI({
      ...data,
      companyId: companyId
    }, (result) => {
      if(callback) callback(result);
    });
  }

  const DeleteFinancialCategory = async (id, callback) => {
    DeleteFinancialCategoryAPI(companyId, id, (result) => {
      if(callback) callback(result);
    });
  }

  // Financial Transactions
  const GetActiveRecurringTransactions = async (callback) => {
    GetActiveRecurringTransactionsAPI(companyId, (result) => {
      if(callback) callback(result);
    });
  }

  const GetFinancialTransactions = async (startDate, endDate, type, categoryId, callback) => {
    GetFinancialTransactionsAPI(companyId, startDate, endDate, type, categoryId, (result) => {
      if(callback) callback(result);
    });
  }

  const SetFinancialTransaction = async (data, callback) => {
    data.createdBy = currentSession?.user?.id;
    SetFinancialTransactionAPI(companyId, data, (result) => {
      if(callback) callback(result);
    });
  }

  const UpdateFinancialTransaction = async (data, callback) => {
    UpdateFinancialTransactionAPI(data, (result) => {
      if(callback) callback(result);
    });
  }

  const DeleteFinancialTransaction = async (id, callback) => {
    DeleteFinancialTransactionAPI(companyId, id, (result) => {
      if(callback) callback(result);
    });
  }

  // Financial Dashboard
  const GetFinancialDashboard = async (month, year, callback) => {
    GetFinancialDashboardAPI(companyId, month, year, (result) => {
      if(callback) callback(result);
    });
  }

  // Resources APIs
  const syncCompanyResourcesState = async (resources) => {
    setCompanyConfig(prevConfig => ({
      ...prevConfig,
      Resources: resources
    }));
  };

  const syncCompanyProceduresState = async (procedures) => {
    setCompanyConfig(prevConfig => ({
      ...prevConfig,
      Procedures: procedures
    }));
  };

  const syncCompanyRoomsState = async (rooms) => {
    setCompanyConfig(prevConfig => ({
      ...prevConfig,
      Rooms: rooms
    }));
  };

  // Operadoras ativas com planos ({ Id, Label, AnsRegistry, Plans: [{ Id, Label }] }), como get_company.php devolve
  const syncCompanyInsuranceProvidersState = async (providers) => {
    setCompanyConfig(prevConfig => ({
      ...prevConfig,
      InsuranceProviders: providers
    }));
  };

  const syncCompanyPaymentMethodsState = async (paymentMethods) => {
    setCompanyConfig(prevConfig => ({
      ...prevConfig,
      PaymentOptions: paymentMethods
    }));
  };

  const syncAnamnesisTemplatesState = async (templates) => {
    setCompanyConfig(prevConfig => ({
      ...prevConfig,
      AnamneseTemplates: templates
    }));
  };

  const syncLeadsSourcesState = async (sources) => {
    setCompanyConfig(prevConfig => ({
      ...prevConfig,
      LeadsSources: sources
    }));
  };

  const syncLeadsCampaignsState = async (campaigns) => {
    setCompanyConfig(prevConfig => ({
      ...prevConfig,
      LeadsCampaigns: campaigns
    }));
  };

  const GetAnamnesisTemplates = async (callback) => {
    GetAnamnesisTemplatesAPI(companyId, (response) => {
      // Atualiza o estado interno do DataProvider com os templates mais recentes
      syncAnamnesisTemplatesState(response);
      if(callback) callback(response);
    });
  };

  const SetAnamnesisTemplate = async (label, questions, callback) => {
    SetAnamnesisTemplateAPI(companyId, { label, questions }, (response) => {
      GetAnamnesisTemplatesAPI(companyId, (templates) => {
        syncAnamnesisTemplatesState(templates);
        if(callback) callback(response);
      });
    });
  };

  const UpdateAnamnesisTemplate = async (data, callback) => {
    UpdateAnamnesisTemplateAPI(data, (response) => {
      GetAnamnesisTemplatesAPI(companyId, (templates) => {
        syncAnamnesisTemplatesState(templates);
        if(callback) callback(response);
      });
    });
  };

  const DeleteAnamnesisTemplate = async (id, callback) => {
    DeleteAnamnesisTemplateAPI(id, (response) => {
      GetAnamnesisTemplatesAPI(companyId, (templates) => {
        syncAnamnesisTemplatesState(templates);
        if(callback) callback(response);
      });
    });
  };

  // Tipos de atendimento (atendimentos modulares): mesma mecânica dos modelos de anamnese
  const syncAppointmentTypesState = (types) => {
    setCompanyConfig(prevConfig => ({
      ...prevConfig,
      AppointmentTypes: types
    }));
  };

  const refreshAppointmentTypes = (response, callback) => {
    GetAppointmentTypesAPI((list) => {
      if (list?.status === 'SUCCESS') syncAppointmentTypesState(list.data);
      if (callback) callback(response);
    });
  };

  const GetAppointmentTypes = async (callback) => {
    refreshAppointmentTypes(null, callback);
  };

  const SetAppointmentType = async (data, callback) => {
    SetAppointmentTypeAPI(data, (response) => refreshAppointmentTypes(response, callback));
  };

  const UpdateAppointmentType = async (data, callback) => {
    UpdateAppointmentTypeAPI(data, (response) => refreshAppointmentTypes(response, callback));
  };

  const DeactivateAppointmentType = async (id, callback) => {
    DeactivateAppointmentTypeAPI(id, (response) => refreshAppointmentTypes(response, callback));
  };

  // Desativados ficam fora de CompanyConfig (a seleção usa só os ativos): a tela pede à parte
  const GetInactiveAppointmentTypes = async (callback) => {
    GetInactiveAppointmentTypesAPI((list) => {
      if (callback) callback(list?.status === 'SUCCESS' ? (list.inactive || []) : []);
    });
  };

  const ReactivateAppointmentType = async (id, callback) => {
    ReactivateAppointmentTypeAPI(id, (response) => refreshAppointmentTypes(response, callback));
  };

  // Etapas do atendimento: as ativas ficam em CompanyConfig.AppointmentSteps (vêm no
  // get_company; o cadastro relê depois de salvar)
  const refreshAppointmentSteps = (response, callback) => {
    GetAppointmentStepsAPI(false, (list) => {
      if (list?.status === 'SUCCESS') {
        setCompanyConfig(prevConfig => ({ ...prevConfig, AppointmentSteps: list.data }));
      }
      if (callback) callback(response);
    });
  };

  // Cor de um status (chave da paleta; vazio volta para a padrão). A agenda inteira usa na hora.
  const SetAppointmentStatusColor = async (status, color, callback) => {
    SetAppointmentStatusColorAPI(status, color, (response) => {
      if (response?.status === 'SUCCESS') {
        const colors = response.data && !Array.isArray(response.data) ? response.data : {};
        setStatusColorOverrides(colors);
        setCompanyConfig(prevConfig => ({ ...prevConfig, AppointmentStatusColors: colors }));
      }
      if (callback) callback(response);
    });
  };

  const GetAppointmentSteps = async (callback) => {
    refreshAppointmentSteps(null, callback);
  };

  const GetInactiveAppointmentSteps = async (callback) => {
    GetAppointmentStepsAPI(true, (list) => {
      if (callback) callback(list?.status === 'SUCCESS' ? (list.inactive || []) : []);
    });
  };

  const SetAppointmentStep = async (data, callback) => {
    SetAppointmentStepAPI(data, (response) => refreshAppointmentSteps(response, callback));
  };

  const SetAppointmentStepActive = async (id, active, callback) => {
    SetAppointmentStepActiveAPI(id, active, (response) => refreshAppointmentSteps(response, callback));
  };

  const ReorderAppointmentSteps = async (status, ids, callback) => {
    ReorderAppointmentStepsAPI(status, ids, (response) => refreshAppointmentSteps(response, callback));
  };

  // Marcar a etapa não recarrega a agenda: a resposta traz as marcações atuais do agendamento
  const CheckAppointmentStep = async (appointmentId, stepId, checked, callback) => {
    CheckAppointmentStepAPI(appointmentId, stepId, checked, callback);
  };

  const syncCompanyMessageTemplatesState = async (templates) => {
    
    
    // Update the separate messageTemplates state
    setMessageTemplates(templates || []);
    
    
    // Also update the CompanyConfig for backward compatibility
    return new Promise(resolve => {
      setCompanyConfig(prevConfig => {
        
        
        if (!prevConfig) {
          
          resolve();
          return prevConfig;
        }
        
        // Create a new config object with the updated message templates
        const newConfig = {
          ...prevConfig,
          MessageTemplates: templates || [] // Ensure we always have an array
        };
        
        // Log the update for debugging
        
        
        
        // Resolve immediately to ensure the promise completes
        resolve();
        
        return newConfig;
      });
    });
  };

  const GetCompanyResources = async (callback) => {
    GetCompanyResourcesAPI(companyId, (result) => {
      if(callback) callback(result);
    });
  }

  const SetCompanyResource = async (data, callback) => {
    SetCompanyResourceAPI(companyId, data, (result) => {
      GetCompanyResourcesAPI(companyId, (resources) => {
        syncCompanyResourcesState(resources);
        if(callback) callback(result);
      });
    });
  }

  const UpdateCompanyResource = async (data, callback) => {
    UpdateCompanyResourceAPI(data, (result) => {
      GetCompanyResourcesAPI(companyId, (resources) => {
        syncCompanyResourcesState(resources);
        if(callback) callback(result);
      });
    });
  }

  const DeleteCompanyResource = async (id, callback) => {
    DeleteCompanyResourceAPI(id, (result) => {
      GetCompanyResourcesAPI(companyId, (resources) => {
        syncCompanyResourcesState(resources);
        if(callback) callback(result);
      });
    });
  }

  // Procedures APIs
  const GetCompanyProcedures = async (callback) => {
    GetCompanyProceduresAPI(companyId, (result) => {
      if(callback) callback(result);
    });
  }

  const SetCompanyProcedure = async (data, callback) => {
    SetCompanyProcedureAPI(companyId, data, (result) => {
      GetCompanyProceduresAPI(companyId, (procedures) => {
        syncCompanyProceduresState(procedures);
        if(callback) callback(result);
      });
    });
  }

  const UpdateCompanyProcedure = async (data, callback) => {
    UpdateCompanyProcedureAPI(data, (result) => {
      GetCompanyProceduresAPI(companyId, (procedures) => {
        syncCompanyProceduresState(procedures);
        if(callback) callback(result);
      });
    });
  }

  const DeleteCompanyProcedure = async (id, callback) => {
    DeleteCompanyProcedureAPI(id, (result) => {
      GetCompanyProceduresAPI(companyId, (procedures) => {
        syncCompanyProceduresState(procedures);
        if(callback) callback(result);
      });
    });
  }

  // Payment Methods APIs
  const GetCompanyPaymentMethods = async (callback) => {
    GetCompanyPaymentMethodsAPI(companyId, (result) => {
      if(callback) callback(result);
    });
  }

  const SetCompanyPaymentMethod = async (data, callback) => {
    SetCompanyPaymentMethodAPI(companyId, data, (result) => {
      GetCompanyPaymentMethodsAPI(companyId, (paymentMethods) => {
        syncCompanyPaymentMethodsState(paymentMethods);
        if(callback) callback(result);
      });
    });
  }

  const UpdateCompanyPaymentMethod = async (data, callback) => {
    UpdateCompanyPaymentMethodAPI(data, (result) => {
      GetCompanyPaymentMethodsAPI(companyId, (paymentMethods) => {
        syncCompanyPaymentMethodsState(paymentMethods);
        if(callback) callback(result);
      });
    });
  }

  const DeleteCompanyPaymentMethod = async (id, callback) => {
    DeleteCompanyPaymentMethodAPI(id, (result) => {
      GetCompanyPaymentMethodsAPI(companyId, (paymentMethods) => {
        syncCompanyPaymentMethodsState(paymentMethods);
        if(callback) callback(result);
      });
    });
  }

  // Automation Settings functions
  const GetCompanyAutomationSettings = async (callback) => {
    return new Promise((resolve) => {
      GetCompanyAutomationSettingsAPI(companyId, (result) => {
        if(callback) callback(result);
        resolve(result);
      });
    });
  }

  const UpdateCompanyAutomationSetting = async (automationType, isEnabled, callback) => {
    return new Promise((resolve) => {
      UpdateCompanyAutomationSettingAPI(companyId, automationType, isEnabled, (result) => {
        if(callback) callback(result);
        resolve(result);
      });
    });
  }

  // Company Setup functions
  const GetCompanySetupStatus = async (callback) => {
    return new Promise((resolve) => {
      GetCompanySetupStatusAPI((result) => {
        if(callback) callback(result);
        resolve(result);
      }, companyId);
    });
  }

  const UpdateCompanySetupStatus = async (status, callback) => {
    return new Promise((resolve) => {
      UpdateCompanySetupStatusAPI(status, (result) => {
        if(callback) callback(result);
        resolve(result);
      });
    });
  }

  // User Profile Methods
  const GetUserProfile = async (callback) => {
    GetUserProfileAPI((response) => {
      if (response.success && response.user) {
        setUserProfile(response.user);
      }
      if (callback) callback(response);
    });
  }

  const UpdateUserProfile = async (name, phone, callback) => {
    setIsUpdating(true);
    UpdateUserProfileAPI(name, phone, (response) => {
      setIsUpdating(false);
      if (callback) callback(response);
      
      // Update session data if successful
      if (response.success) {
        // Refresh user profile data
        GetUserProfile();
        
        // Also update session for backward compatibility
        if (currentSession && currentSession.user && currentSession.user.profile) {
          currentSession.user.profile.name = name;
          currentSession.user.profile.phone = phone;
          localStorage.setItem('sessionData', JSON.stringify(currentSession));
          setCurrentSession({...currentSession});
        }
      }
    });
  }

  const UpdateUserPicture = async (pictureFile, callback) => {
    setIsUpdating(true);
    UpdateUserPictureAPI(pictureFile, (response) => {
      setIsUpdating(false);
      if (callback) callback(response);
      
      // Update session data if successful
      if (response.success) {
        // Refresh user profile data
        GetUserProfile();
        
        // Also update session for backward compatibility
        if (currentSession && currentSession.user && currentSession.user.profile) {
          currentSession.user.profile.picture = response.picture;
          localStorage.setItem('sessionData', JSON.stringify(currentSession));
          setCurrentSession({...currentSession});
        }
      }
    });
  }

  const UpdateUserPassword = async (currentPassword, newPassword, callback) => {
    setIsUpdating(true);
    UpdateUserPasswordAPI(currentPassword, newPassword, (response) => {
      setIsUpdating(false);
      if (callback) callback(response);
    });
  }

  // Sessões ativas do usuário logado (L-21)
  const ListUserSessions = (callback) => {
    ListUserSessionsAPI(callback);
  }

  // target: { sessionId } para uma sessão, { others: true } para todas as outras
  const RevokeUserSession = (target, callback) => {
    RevokeUserSessionAPI(target, callback);
  }

  // Preferências de comunicação do usuário logado (Novidades por e-mail)
  const GetCommunicationPreferences = (callback) => {
    GetCommunicationPreferencesAPI(callback);
  }

  const UpdateCommunicationPreferences = (preferences, callback) => {
    UpdateCommunicationPreferencesAPI(preferences, callback);
  }

  const GetMassMessagingRecipients = (queryType, parameters, filterHistory = true, historyDays = 30, callback) => {
    GetMassMessagingRecipientsAPI(companyId, queryType, parameters, filterHistory, historyDays, callback);
  }

  const SendMassMessage = (recipients, messageTemplate, variables, channel, queryType = null, callback) => {
   var userId = currentSession?.user?.id;
    SendMassMessageAPI(companyId, userId, recipients, messageTemplate, variables, channel, queryType, callback);
  }

  const GetMassMessageHistory = (recipientId = null, queryType = null, startDate = null, endDate = null, page = 1, limit = 50, callback) => {
    GetMassMessageHistoryAPI(companyId, recipientId, queryType, startDate, endDate, page, limit, callback);
  }

  const CheckRecipientMassMessageHistory = (recipientId, queryType, daysThreshold = 30, callback) => {
    CheckRecipientMassMessageHistoryAPI(companyId, recipientId, queryType, daysThreshold, callback);
  }

  const GetPredefinedQueries = (callback) => {
    GetPredefinedQueriesAPI(callback);
  }

  const ReportProblem = (formData, callback) => {
    ReportProblemAPI(formData, callback);
  }

  const SuggestImprovement = (formData, callback) => {
    SuggestImprovementAPI(formData, callback);
  }
  
  const EvaluateProduct = (formData, callback) => {
    EvaluateProductAPI(formData, callback);
  }

  const Contact = (formData, callback) => {
    ContactAPI(formData, callback);
  }

  const GetSystemFeedback = (startDate, endDate, type, status, callback) => {
    GetSystemFeedbackAPI(companyId, startDate, endDate, type, status, callback);
  }

  const UpdateSystemFeedback = (feedbackId, status, callback) => {
    const updatedBy = currentSession?.user?.id;
    UpdateSystemFeedbackAPI(feedbackId, status, updatedBy, callback);
  }

  const GetSystemNps = (startDate, endDate, callback) => {
    GetSystemNpsAPI(companyId, startDate, endDate, callback);
  }
  
  const GetUserNps = (callback) => {
    GetUserNpsAPI(callback);
  }

  const UploadFeedbackFile = (formData, callback) => {
    UploadFeedbackFileAPI(formData, callback);
  }

  // Terms and Privacy functions
  const AcceptTerms = async (callback) => {
    AcceptTermsAPI(companyId, (response) => {
      callback(response);
    });
  }

  const CheckTermsAccepted = async (callback) => {
    CheckTermsAcceptedAPI(companyId, (response) => {
      callback(response);
    });
  }

  const GetTermsContent = async (callback) => {
    GetTermsContentAPI((response) => {
      callback(response);
    });
  }

  // Rooms functions
  const GetCompanyRooms = useCallback(async (callback) => {
    GetCompanyRoomsAPI(companyId, (result) => {
      if (callback) callback(result);
    });
  }, [companyId]);

  const SetCompanyRoom = async (data, callback) => {
    const createdBy = currentSession?.user?.id;
    SetCompanyRoomAPI(companyId, createdBy, data, (result) => {
      GetCompanyRoomsAPI(companyId, (rooms) => {
        // Transform rooms data to match CompanyConfig format
        const transformedRooms = rooms?.filter(room => room.is_active).map(room => ({
          Id: String(room.id),
          Label: room.name,
          Capacity: String(room.capacity)
        })) || [];
        syncCompanyRoomsState(transformedRooms);
        if (callback) callback(result);
      });
    });
  };

  const UpdateCompanyRoom = async (data, callback) => {
    UpdateCompanyRoomAPI(data, (result) => {
      GetCompanyRoomsAPI(companyId, (rooms) => {
        // Transform rooms data to match CompanyConfig format
        const transformedRooms = rooms?.filter(room => room.is_active).map(room => ({
          Id: String(room.id),
          Label: room.name,
          Capacity: String(room.capacity)
        })) || [];
        syncCompanyRoomsState(transformedRooms);
        if (callback) callback(result);
      });
    });
  };

  // Convênios (docs/features/convenios). Depois de gravar uma operadora, CompanyConfig.InsuranceProviders
  // é recarregado no mesmo formato de get_company.php (só ativas, com planos ativos).
  const insuranceProvidersToConfig = (providers) => (providers || [])
    .filter(p => Number(p.active) === 1)
    .map(p => ({
      Id: String(p.id),
      Label: p.name,
      AnsRegistry: p.ans_registry || null,
      Plans: (p.plans || []).filter(pl => Number(pl.active) === 1).map(pl => ({ Id: String(pl.id), Label: pl.name })),
      Procedures: (p.procedures || []).filter(pr => Number(pr.active) === 1).map(pr => ({
        Id: String(pr.id), Code: pr.code, Name: pr.name, Price: pr.price, ProcedureId: pr.procedure_id != null ? String(pr.procedure_id) : null
      }))
    }));

  const GetInsuranceProviders = useCallback(async (callback) => {
    GetInsuranceProvidersAPI((result) => {
      if (callback) callback(result);
    });
  }, []);

  const refreshInsuranceProvidersConfig = (result, callback) => {
    GetInsuranceProvidersAPI((list) => {
      if (list?.status === 'SUCCESS' && Array.isArray(list.data)) {
        syncCompanyInsuranceProvidersState(insuranceProvidersToConfig(list.data));
      }
      if (callback) callback(result);
    });
  };

  const SetInsuranceProvider = async (data, callback) => {
    SetInsuranceProviderAPI(data, (result) => refreshInsuranceProvidersConfig(result, callback));
  };

  const UpdateInsuranceProvider = async (data, callback) => {
    UpdateInsuranceProviderAPI(data, (result) => refreshInsuranceProvidersConfig(result, callback));
  };

  const SearchTussProcedures = useCallback(async (query, callback) => {
    SearchTussProceduresAPI(query, (result) => { if (callback) callback(result); });
  }, []);

  const SetInsuranceProcedure = async (data, callback) => {
    SetInsuranceProcedureAPI(data, (result) => refreshInsuranceProvidersConfig(result, callback));
  };

  const UpdateInsuranceProcedure = async (data, callback) => {
    UpdateInsuranceProcedureAPI(data, (result) => refreshInsuranceProvidersConfig(result, callback));
  };

  const CopyInsuranceProcedures = async (fromProviderId, toProviderId, callback) => {
    CopyInsuranceProceduresAPI(fromProviderId, toProviderId, (result) => refreshInsuranceProvidersConfig(result, callback));
  };

  const GetPatientInsurances = useCallback(async (patientId, callback) => {
    GetPatientInsurancesAPI(patientId, (result) => { if (callback) callback(result); });
  }, []);

  const SetPatientInsurance = async (data, callback) => {
    SetPatientInsuranceAPI(data, (result) => { if (callback) callback(result); });
  };

  const UpdatePatientInsurance = async (data, callback) => {
    UpdatePatientInsuranceAPI(data, (result) => { if (callback) callback(result); });
  };

  const GetPatientInsuranceDocuments = useCallback(async (patientId, callback) => {
    GetPatientInsuranceDocumentsAPI(patientId, (result) => { if (callback) callback(result); });
  }, []);

  const SetMedicalRequest = async (data, callback) => {
    SetMedicalRequestAPI(data, (result) => { if (callback) callback(result); });
  };

  const UpdateMedicalRequest = async (data, callback) => {
    UpdateMedicalRequestAPI(data, (result) => { if (callback) callback(result); });
  };

  const SetInsuranceAuthorization = async (data, callback) => {
    SetInsuranceAuthorizationAPI(data, (result) => { if (callback) callback(result); });
  };

  const UpdateInsuranceAuthorization = async (data, callback) => {
    UpdateInsuranceAuthorizationAPI(data, (result) => { if (callback) callback(result); });
  };

  const GetAppointmentInsuranceDocuments = useCallback(async (appointmentId, callback) => {
    GetAppointmentInsuranceDocumentsAPI(appointmentId, (result) => { if (callback) callback(result); });
  }, []);

  const LinkAppointmentInsuranceDocument = async (appointmentId, documentType, documentId, callback) => {
    LinkAppointmentInsuranceDocumentAPI(appointmentId, documentType, documentId, (result) => { if (callback) callback(result); });
  };

  const UnlinkAppointmentInsuranceDocument = async (linkId, callback) => {
    UnlinkAppointmentInsuranceDocumentAPI(linkId, (result) => { if (callback) callback(result); });
  };

  const GetUpcomingRequestTargets = async (appointmentId, requestId, callback) => {
    GetUpcomingRequestTargetsAPI(appointmentId, requestId, (result) => { if (callback) callback(result); });
  };

  const LinkUpcomingRequest = async (appointmentId, requestId, callback) => {
    LinkUpcomingRequestAPI(appointmentId, requestId, (result) => { if (callback) callback(result); });
  };

  const GetInsurancePending = useCallback(async (filters, callback) => {
    GetInsurancePendingAPI(filters, (result) => { if (callback) callback(result); });
  }, []);

  const DeleteCompanyRoom = async (roomId, callback) => {
    DeleteCompanyRoomAPI(roomId, (result) => {
      GetCompanyRoomsAPI(companyId, (rooms) => {
        // Transform rooms data to match CompanyConfig format
        const transformedRooms = rooms?.filter(room => room.is_active).map(room => ({
          Id: String(room.id),
          Label: room.name,
          Capacity: String(room.capacity)
        })) || [];
        syncCompanyRoomsState(transformedRooms);
        if (callback) callback(result);
      });
    });
  };

  const GetRoomOccupancy = useCallback(async (roomId, startDateTime, endDateTime, callback) => {
    GetRoomOccupancyAPI(roomId, startDateTime, endDateTime, (result) => {
      if (callback) callback(result);
    });
  }, []);

  const GetRoomsOccupancyBatch = useCallback(async (roomIds, startDateTime, endDateTime, callback) => {
    GetRoomsOccupancyBatchAPI(roomIds, startDateTime, endDateTime, (result) => {
      if (callback) callback(result);
    });
  }, []);

  // Sala do dia (RECEP-01)
  const GetDayRooms = useCallback(async (date, callback) => {
    GetDayRoomsAPI(date, (result) => {
      if (callback) callback(result);
    });
  }, []);

  const SetDayRoom = useCallback(async (data, callback) => {
    SetDayRoomAPI(data, (result) => {
      if (callback) callback(result);
    });
  }, []);

  // ─── Fiscal (NFS-e) functions ───────────────────────────────────────────────

  const GetFiscalSettings = (callback) => {
    GetFiscalSettingsAPI((result) => {
      if (callback) callback(result);
    });
  };

  const SetFiscalSettings = (settings, callback) => {
    SetFiscalSettingsAPI(settings, (result) => {
      if (callback) callback(result);
    });
  };

  const GetFiscalInvoice = (params, callback) => {
    GetFiscalInvoiceAPI(params, (result) => {
      if (callback) callback(result);
    });
  };

  const CreateFiscalInvoice = (data, callback) => {
    CreateFiscalInvoiceAPI(data, (result) => {
      if (callback) callback(result);
    });
  };

  const RefreshFiscalInvoiceStatus = (invoiceId, callback) => {
    RefreshFiscalInvoiceStatusAPI(invoiceId, (result) => {
      if (callback) callback(result);
    });
  };

  const SendFiscalInvoiceWhatsApp = (invoiceId, callback) => {
    SendFiscalInvoiceWhatsAppAPI(invoiceId, (result) => {
      if (callback) callback(result);
    });
  };

  const DownloadFiscalFile = (invoiceId, type) => {
    DownloadFiscalFileAPI(invoiceId, type);
  };

  const GetFiscalDownloadUrl = (invoiceId, type) => {
    return GetFiscalInvoiceDownloadUrl(invoiceId, type);
  };

  const CancelFiscalInvoice = (data, callback) => {
    CancelFiscalInvoiceAPI(data, (result) => {
      if (callback) callback(result);
    });
  };

  const GetFiscalInvoiceHistory = (appointmentId, callback) => {
    GetFiscalInvoiceHistoryAPI(appointmentId, companyId, (result) => {
      if (callback) callback(result);
    });
  };

  const allData =
  {
    isUpdating,
    session: currentSession,
    // Terms and Privacy
    AcceptTerms,
    CheckTermsAccepted,
    GetTermsContent,
    GetSystemFeedback,
    UpdateSystemFeedback,
    GetSystemNps,
    UploadFeedbackFile,
    // Rooms functions
    GetCompanyRooms,
    SetCompanyRoom,
    UpdateCompanyRoom,
    DeleteCompanyRoom,
    GetRoomOccupancy,
    GetRoomsOccupancyBatch,
    GetDayRooms,
    SetDayRoom,
    // Convênios
    GetInsuranceProviders,
    SetInsuranceProvider,
    UpdateInsuranceProvider,
    SearchTussProcedures,
    SetInsuranceProcedure,
    UpdateInsuranceProcedure,
    CopyInsuranceProcedures,
    GetPatientInsurances,
    SetPatientInsurance,
    UpdatePatientInsurance,
    GetPatientInsuranceDocuments,
    SetMedicalRequest,
    UpdateMedicalRequest,
    SetInsuranceAuthorization,
    UpdateInsuranceAuthorization,
    GetAppointmentInsuranceDocuments,
    LinkAppointmentInsuranceDocument,
    UnlinkAppointmentInsuranceDocument,
    GetUpcomingRequestTargets,
    LinkUpcomingRequest,
    GetInsurancePending,
    // Fiscal (NFS-e) functions
    GetFiscalSettings,
    SetFiscalSettings,
    GetFiscalInvoice,
    GetFiscalInvoiceHistory,
    CreateFiscalInvoice,
    RefreshFiscalInvoiceStatus,
    SendFiscalInvoiceWhatsApp,
    DownloadFiscalFile,
    GetFiscalDownloadUrl,
    CancelFiscalInvoice,
    UserData: userData, // Use our enhanced userData that includes the role
    CompanyConfig, GetCompany, UpdateCompany, UpdateCompanyConfig,
    GetLeads, SetLead, UpdateLead, DeleteLead, FindLeadByPhone,
    GetCampaigns, SetCampaign, UpdateCampaign, DeleteCampaign, GetMarketingCampaignsByChannel,
    GetMarketingChannels, SetMarketingChannel, UpdateMarketingChannel, DeleteMarketingChannel,
    GetProcedureById, GetResourceById,
    GetCEPInfo,
    GetDashboard,
    GetAppointmentsKpi,
    GetReportsAppointments,GetReportsFinancial,
    patients, patientsLoadedAt, GetPatients, SetPatient, UpdatePatient, GetPatientById,
    SetPatientAnamnese, UpdatePatientAnamnese, DeletePatientAnamnese, SetPatientDocument,
    appointments,GetAppointments, SetAppointment, UpdateAppointment, DeleteAppointment,
    PreviewRecurringAppointments, CreateRecurringAppointments,
    GetWaitingList, SetWaitingList, UpdateWaitingList, DeleteWaitingList, CheckWaitingListAvailability,
    GetWaitingListOffers, SetWaitingListOffer, UpdateWaitingListOffer,
    GetInvoice, SetAppointmentInvoice, UpdateInvoice, UpdateInvoiceNfIssued, DeleteInvoice,
    SetPatientHistory, SetPatientNote, AnnulPatientHistoryRecord, CreateReplacementHistoryRecord, SetPatientCranialAsymmetry, UpdatePatientCranialAsymmetry, DeletePatientCranialAsymmetry,
    SetPatientBodyMeasurements, UpdatePatientBodyMeasurements, DeletePatientBodyMeasurements, SetPatientBodyMap, SetPatientMealPlan, UpdatePatientMealPlan, DeletePatientMealPlan, SetPatientApplicationMap, SetApplicationProducts, SetPatientScaleAssessment, SetPatientGrowthMeasurement, DeletePatientGrowthMeasurement, SetPatientMotorMilestone, DeletePatientMotorMilestone, SetPatientThermography, DeletePatientThermography, SetPatientAimsAssessment, DeletePatientAimsAssessment, SetPatientBirthInfo, SetPatientPrescription, DeletePatientPrescription, SetPrescriptionTemplate, DeletePrescriptionTemplate, SearchIcd, SetPatientDiagnosis, DeletePatientDiagnosis,
    CreatePatientRegistrationLink,
    SendPatientRegistrationLinkWhatsApp,
    SetPatientRegistrationLinkOrigin,
    CreateAppointmentReservation,
    GetAppointmentReservation,
    ResendAppointmentReservation,
    NotifyReleasedAppointmentReservation,
    UploadPatientAttachment, ListPatientAttachments, UpdatePatientAttachment, DeletePatientAttachment, GetPatientAttachmentFile,
    AnalyzeCranialImage,
    GetTemplatesDocuments, SetTemplatesDocuments, UpdateTemplatesDocuments, DeleteTemplatesDocuments, syncDocumentTemplatesState,
    // Use the separate messageTemplates state for templates
    MessageTemplates: messageTemplates,
    GetMessageTemplates, UpdateMessageTemplate, syncCompanyMessageTemplatesState,
    GetAnamnesisTemplates, SetAnamnesisTemplate, UpdateAnamnesisTemplate, DeleteAnamnesisTemplate,
    GetAppointmentTypes, SetAppointmentType, UpdateAppointmentType, DeactivateAppointmentType,
    GetInactiveAppointmentTypes, ReactivateAppointmentType,
    GetAppointmentSteps, GetInactiveAppointmentSteps, SetAppointmentStep, SetAppointmentStepActive,
    ReorderAppointmentSteps, CheckAppointmentStep, SetAppointmentStatusColor,
    GetWhatsappChats, GetWhatsappChatMessages, SetWhatsappChatRead, GetWhatsappContactContext, SendWhatsappMessage, SendWhatsappDocument, GetWhatsappConfig, SetWhatsappConfig, TestWhatsappConfig, GetWhatsappDeviceInfo, GetWhatsappQRCode, GetWhatsappPhoneCode, DisconnectWhatsapp, GetWhatsappSenderStatus, SetWhatsappSenderToggles, NotifyAppointmentPatientWhatsApp,
    // Company Setup functions
    GetCompanySetupStatus, UpdateCompanySetupStatus,
    GenerateAISimulatorReply,
    GetAISettings,
    SetAISettings,
    GetWhatsappAISuggestion,
    SetWhatsappAISuggestionOutcome,
    // User Management functions
    RegisterUser: (data, callback) => {
      RegisterAPI(data, (result) => {
        if(callback) callback(result);
      });
    },
    // healthRequested: dono marca na hora do aceite; admin deixa um pedido para o dono aprovar
    InviteUser: (email, roleName, healthRequested, callback) => {
      const roleId = ROLE_IDS[roleName];
      if (!roleId) {
        callback({ error: 'Invalid role' });
        return;
      }

      InviteUserAPI(companyId, email, roleId, healthRequested, (result) => {
        if(callback) callback(result);
      });
    },
    AcceptInvite: (token, data, callback) => {
      AcceptInviteAPI(token, data, (result) => {
        if(callback) callback(result);
      });
    },
    GetCompanyUsers: (callback) => {
      GetCompanyUsersAPI(companyId, (result) => {
        if(callback) callback(result);
      });
    },
    RevokeUser: (userId, callback) => {
      RevokeUserAPI(companyId, userId, (result) => {
        if(callback) callback(result);
      });
    },
    ReactivateUser: (userId, callback) => {
      ReactivateUserAPI(companyId, userId, (result) => {
        if(callback) callback(result);
      });
    },
    CancelInvite: (invitationId, callback) => {
      CancelInviteAPI(companyId, invitationId, (result) => {
        if(callback) callback(result);
      });
    },
    ResendInvite: (invitationId, callback) => {
      ResendInviteAPI(companyId, invitationId, (result) => {
        if(callback) callback(result);
      });
    },
    UpdateUser: (userId, roleName, callback) => {
      const roleId = ROLE_IDS[roleName];
      if (!roleId) {
        callback({ error: 'Invalid role' });
        return;
      }

      UpdateUserAPI(companyId, userId, roleId, (result) => {
        if(callback) callback(result);
      });
    },
    TransferOwnership: (targetUserId, password, callback) => {
      TransferOwnershipAPI(companyId, targetUserId, password, (result) => {
        // O papel fica em cache na sessão: recarrega para o selo e as telas do dono mudarem já
        if (result && result.success) {
          GetSessionAPI((sessionResult) => {
            if (!sessionResult.error) setCurrentSession(sessionResult.session);
          });
        }
        if(callback) callback(result);
      });
    },
    // Só o proprietário liga ou desliga a marcação "Profissional de saúde" de alguém
    SetHealthProfessional: (userId, enabled, callback, scheduleScope = null) => {
      SetHealthProfessionalAPI(companyId, userId, enabled, (result) => {
        // A marcação fica em cache na sessão: ao mudar a própria, recarrega para as travas da tela
        if (result && result.success && result.changed && userId == currentSession?.user?.id) {
          GetSessionAPI((sessionResult) => {
            if (!sessionResult.error) setCurrentSession(sessionResult.session);
          });
        }
        if(callback) callback(result);
      }, scheduleScope);
    },
    // Só o proprietário liga a pessoa a uma agenda e define o alcance "Só os meus pacientes"
    SetScheduleLink: (userId, resourceId, scheduleScope, callback) => {
      SetScheduleLinkAPI(companyId, userId, resourceId, scheduleScope, (result) => {
        // O alcance fica em cache na sessão: ao mudar o próprio, recarrega para a agenda e as listas
        if (result && result.success && result.changed && userId == currentSession?.user?.id) {
          GetSessionAPI((sessionResult) => {
            if (!sessionResult.error) setCurrentSession(sessionResult.session);
          });
        }
        if(callback) callback(result);
      });
    },
    // Export functions
    CreateExportJob: (includeAttachments, callback) => {
      CreateExportJobAPI(companyId, includeAttachments, (result) => {
        if(callback) callback(result);
      });
    },
    GetExportStatus: (exportId, callback) => {
      GetExportStatusAPI(exportId, companyId, (result) => {
        if(callback) callback(result);
      });
    },
    GetExportHistory: (callback) => {
      GetExportHistoryAPI(companyId, (result) => {
        if(callback) callback(result);
      });
    },
    CancelExport: (exportId, callback) => {
      CancelExportAPI(exportId, companyId, (result) => {
        if(callback) callback(result);
      });
    },
    GetExportEstimate: (callback) => {
      GetExportEstimateAPI(companyId, (result) => {
        if(callback) callback(result);
      });
    },
    GetBackupStatus: (callback) => {
      GetBackupStatusAPI(companyId, (result) => {
        if(callback) callback(result);
      });
    },
    // NPS functions
    GetNPSResponses, SetNPSResponse, UpdateNPSGoogleReview, PrepareManualNPSMessage, GetGoogleReviewSuggestions, GetUserNps,
    // Financial functions
    GetFinancialCategories, SetFinancialCategory, UpdateFinancialCategory, DeleteFinancialCategory,
    GetFinancialTransactions, SetFinancialTransaction, UpdateFinancialTransaction, DeleteFinancialTransaction, GetActiveRecurringTransactions,
    GetFinancialDashboard,
    // Resources and Procedures functions
    GetCompanyResources, SetCompanyResource, UpdateCompanyResource, DeleteCompanyResource,
    GetCompanyProcedures, SetCompanyProcedure, UpdateCompanyProcedure, DeleteCompanyProcedure,
    GetCompanyPaymentMethods, SetCompanyPaymentMethod, UpdateCompanyPaymentMethod, DeleteCompanyPaymentMethod,
    syncCompanyResourcesState, syncCompanyProceduresState, syncCompanyRoomsState, syncCompanyPaymentMethodsState,
    // Automation Settings
    GetCompanyAutomationSettings, UpdateCompanyAutomationSetting,
    // Mass Messaging
    GetMassMessagingRecipients, SendMassMessage, GetPredefinedQueries, GetMassMessageHistory, CheckRecipientMassMessageHistory,
    // Support
    ReportProblem, SuggestImprovement, EvaluateProduct, Contact,
    // User Profile Methods
    GetUserProfile, UpdateUserProfile, UpdateUserPicture, UpdateUserPassword,
    ListUserSessions, RevokeUserSession, GetCommunicationPreferences, UpdateCommunicationPreferences,
    // Package functions
    GetPackages: (callback) => {
      GetServicePackagesAPI(companyId, (result) => {
        if(callback) callback(result);
      });
    },
    CreatePackage: (data, callback) => {
      CreateServicePackageAPI(companyId, data, (result) => {
        if(callback) callback(result);
      });
    },
    UpdatePackage: (packageId, data, callback) => {
      UpdateServicePackageAPI(packageId, data, (result) => {
        if(callback) callback(result);
      });
    },
    DeletePackage: (packageId, callback) => {
      DeleteServicePackageAPI(packageId, (result) => {
        if(callback) callback(result);
      });
    },
    // Wallet functions
    GetPatientWallet: (patientId, callback) => {
      GetPatientWalletAPI(patientId, (result) => {
        if(callback) callback(result);
      });
    },
    GetWalletTransactions: (walletId, startDate, endDate, callback) => {
      GetWalletTransactionsAPI(walletId, startDate, endDate, (result) => {
        if(callback) callback(result);
      });
    },
    GetServicePackages: (callback) => {
      GetServicePackagesAPI(companyId, (result) => {
        if(callback) callback(result);
      });
    },
    PurchaseServicePackage: (walletId, packageId, paymentMethod, paymentStatus, callback) => {
      const createdBy = userData.id;
      PurchaseServicePackageAPI(walletId, packageId, paymentMethod, paymentStatus, createdBy, (result) => {
        if(callback) callback(result);
      });
    },
    DeductWalletCredits: (walletId, procedureId, description, callback) => {
      const createdBy = userData.id;
      DeductWalletCreditsAPI(walletId, procedureId, description, createdBy, (result) => {
        if(callback) callback(result);
      });
    },
    
    // Subscription functions
    GetSubscriptionPlans: (callback) => {
      GetSubscriptionPlansAPI((result) => {
        if(callback) callback(result);
      });
    },
    
    GetCompanySubscription: (callback) => {
      GetCompanySubscriptionAPI((result) => {
        if(callback) callback(result);
      });
    },
    
    UpdateCompanySubscriptionPlan: (planId, prorationEnabled = true, whenToApply = 'now', callback) => {
      UpdateCompanySubscriptionPlanAPI(planId, prorationEnabled, whenToApply, (result) => {
        if(callback) callback(result);
      });
    },

    SimulatePlanChange: (planId, prorationEnabled = true, whenToApply = 'now', callback) => {
      SimulatePlanChangeAPI(planId, prorationEnabled, whenToApply, (result) => {
        if(callback) callback(result);
      });
    },

    GetSubscriptionHistory: (page = 1, limit = 10, callback) => {
      GetSubscriptionHistoryAPI(page, limit, (result) => {
        if(callback) callback(result);
      });
    },

    CancelCompanySubscription: (callback, cancelReason = null, cancelReasonDetails = null) => {
      CancelCompanySubscriptionAPI((result) => {
        if(callback) callback(result);
      }, cancelReason, cancelReasonDetails);
    },
    
    CancelSpecificSubscription: (subscriptionId, callback) => {
      CancelSpecificSubscriptionAPI(subscriptionId, (result) => {
        if(callback) callback(result);
      });
    },
    
    GetSubscriptionPaymentHistory: (page = 1, limit = 10, callback) => {
      GetSubscriptionPaymentHistoryAPI(page, limit, (result) => {
        if(callback) callback(result);
      });
    },
    
    // Stripe functions
    CreateStripeCheckoutSession: (planId, callback) => {
      CreateStripeCheckoutSessionAPI(planId, (result) => {
        if(callback) callback(result);
      });
    },
    
    CreateStripeCustomerPortal: (callback) => {
      CreateStripeCustomerPortalAPI((result) => {
        if(callback) callback(result);
      });
    },
    
    GetStripeCheckoutSession: (sessionId, callback) => {
      GetStripeCheckoutSessionAPI(sessionId, (result) => {
        if(callback) callback(result);
      });
    },
    GetStripeConfig: (callback) => {
      GetStripeConfigAPI((result) => {
        if(callback) callback(result);
      });
    },
    
    // Google Business functions
    GetGoogleBusinessConfig: (callback) => {
      GetGoogleBusinessConfigAPI((result) => {
        if(callback) callback(result);
      });
    },
    
    SetGoogleBusinessConfig: (googleReviewUrl, maskedUrl, callback) => {
      SetGoogleBusinessConfigAPI(googleReviewUrl, maskedUrl, (result) => {
        if(callback) callback(result);
      });
    }
  };

  return (
    <DataContext.Provider value={allData}>
      {children}
    </DataContext.Provider>
  );
};

export const DataProviderInstance = () => useContext(DataContext);